import Button from '../../../components/Button'
import Card from '../../../components/Card'
import { generateMaterial } from '../installService'
import { strings as S } from '../strings'

export default function TopicsTab({ onRun }) {
  return (
    <Card
      title={S.topics.cardTitle}
      footer={
        <Button variant="success" onClick={() => onRun(() => generateMaterial())}>
          {S.topics.action}
        </Button>
      }
    />
  )
}
